import { render, staticRenderFns } from "./Submit.vue?vue&type=template&id=12792b67&scoped=true&"
import script from "./Submit.vue?vue&type=script&lang=js&"
export * from "./Submit.vue?vue&type=script&lang=js&"
import style0 from "./Submit.vue?vue&type=style&index=0&id=12792b67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12792b67",
  null
  
)

export default component.exports